(() => {
  const mobileMedia = window.matchMedia('(max-width: 749px)');
  let footerIndex = 0;

  const setEntryState = (entry, open) => {
    entry.button.setAttribute('aria-expanded', String(open));
    entry.list.hidden = !open;
    entry.block.classList.toggle('is-open', open);
  };

  const setupFooter = (footer) => {
    if (footer.dataset.crystifyAccordionReady === 'true') return;

    const blocks = Array.from(
      footer.querySelectorAll('.footer-block--menu')
    );

    if (!blocks.length) return;

    footer.dataset.crystifyAccordionReady = 'true';

    const instance = footerIndex++;
    const entries = [];

    blocks.forEach((block, index) => {
      const heading = block.querySelector(
        ':scope > .footer-block__heading'
      );

      const list = block.querySelector(
        ':scope > .footer-block__details-content'
      );

      if (!heading || !list) return;

      list.id =
        list.id || `CrystifyFooterMenu-${instance}-${index}`;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'crystify-footer-toggle';
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', list.id);

      const label = document.createElement('span');
      label.textContent = heading.textContent.trim();

      const icon = document.createElement('span');
      icon.className = 'crystify-footer-toggle__icon';
      icon.setAttribute('aria-hidden', 'true');

      button.append(label, icon);
      heading.insertAdjacentElement('afterend', button);

      const entry = {
        block,
        heading,
        list,
        button
      };

      entries.push(entry);

      button.addEventListener('click', () => {
        if (!mobileMedia.matches) return;

        const willOpen =
          button.getAttribute('aria-expanded') !== 'true';

        entries.forEach((item) => setEntryState(item, false));

        if (willOpen) {
          setEntryState(entry, true);
        }
      });
    });

    const syncLayout = () => {
      if (mobileMedia.matches) {
        entries.forEach((entry) => {
          entry.heading.hidden = true;
          entry.button.hidden = false;
          setEntryState(entry, false);
        });
      } else {
        entries.forEach((entry) => {
          entry.heading.hidden = false;
          entry.button.hidden = true;
          entry.button.setAttribute('aria-expanded', 'false');
          entry.list.hidden = false;
          entry.block.classList.remove('is-open');
        });
      }
    };

    if (mobileMedia.addEventListener) {
      mobileMedia.addEventListener('change', syncLayout);
    } else {
      mobileMedia.addListener(syncLayout);
    }

    syncLayout();
  };

  const initialise = (root = document) => {
    if (root.matches && root.matches('footer.footer')) {
      setupFooter(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('footer.footer').forEach(setupFooter);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise());
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialise(event.target);
  });
})();